export const ENTRY_PERMISSION = 'settings';

export const ENTRY_LINK = {
  path: '/bulk-eligibility',
  text: 'Eligibility',
  module: 'bulk-eligibility',
  component: 'Dashboard',
  permission: ENTRY_PERMISSION,
};
